import type { JwtPayload } from 'jwt-decode';

import { authChangeGroup } from '@/api/gen-new/auth/auth';
import { getSession, saveSession } from '@/auth/AuthSession';
import { jwtDecode } from 'jwt-decode';

type UserGroupJwtPayload = {
	userGroupId: number;
	preferredCurrency: string;
	preferredLang: string;
} & JwtPayload;

/**
 * Moves the session to another space. The caller reloads the page afterwards: rebuilding every
 * space-scoped query in place is not worth it.
 */
export async function switchActiveSpace(groupId: number): Promise<void> {
	const oldSession = getSession();
	if (!oldSession) {
		throw new Error('No session found');
	}

	const { accessToken, expiresIn, refreshToken, refreshTokenExpiresIn } = await authChangeGroup(groupId);
	const tokenData = jwtDecode<UserGroupJwtPayload>(accessToken);

	saveSession({
		...oldSession,
		userId: Number(tokenData.sub),
		userGroupId: tokenData.userGroupId,
		preferredCurrency: tokenData.preferredCurrency,
		preferredLang: tokenData.preferredLang,
		isLoggedIn: true,
		accessToken,
		expiresIn,
		refreshToken,
		refreshTokenExpiresIn,
	});
}
